import { render, staticRenderFns } from "./BonosV2.vue?vue&type=template&id=9130fdec&scoped=true&"
import script from "./BonosV2.vue?vue&type=script&lang=js&"
export * from "./BonosV2.vue?vue&type=script&lang=js&"
import style0 from "./BonosV2.vue?vue&type=style&index=0&id=9130fdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9130fdec",
  null
  
)

export default component.exports